module.exports = __webpack_public_path__ + "static/img/UTSG老师_黑黑.16b89cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_黑黑.png
// module id = MOav
// module chunks = 0